/* @ngInject */
function TaskPriorityBadgeController ($timeout, $element) {
  activate()

  function activate () {
    $timeout(function () {
      jQuery($element).children('.priority-badge-popup').popup()
    }, 100, false)
  }
}

export { TaskPriorityBadgeController }
